import { BILLING_FREQUENCY_ORDER } from '@proposify/pricing-engine';
import type { BillingFrequency, FrequencyTotals } from '@proposify/pricing-engine';

const ONE_TIME_FREQUENCY: BillingFrequency = 'one-time';

const HEADER_SUFFIX_FALLBACKS: Record<Exclude<BillingFrequency, 'one-time'>, string> = {
  daily: '/daily',
  weekly: '/weekly',
  'bi-weekly': '/bi-weekly',
  monthly: '/monthly',
  quarterly: '/quarterly',
  annual: '/annually',
};

export type HeaderFrequencyEntry = {
  frequency: BillingFrequency;
  total: string;
  suffixKey: string;
  fallbackSuffix: string;
};

const toTranslationKeySegment = (frequency: BillingFrequency): string => frequency.replace(/-/g, '_');

/**
 * Entries for the preview-header per-frequency totals strip, in engine order with
 * one-time first. Empty when there is nothing beyond one-time to show — the header
 * then keeps its single-total rendering.
 */
export const getHeaderFrequencySummary = (
  presentFrequencies: BillingFrequency[],
  frequencyTotals: FrequencyTotals | null
): HeaderFrequencyEntry[] => {
  if (!frequencyTotals) return [];

  const orderedPresent = BILLING_FREQUENCY_ORDER.filter((frequency) => presentFrequencies.includes(frequency));
  const hasNonOneTime = orderedPresent.some((frequency) => frequency !== ONE_TIME_FREQUENCY);
  if (!hasNonOneTime) return [];

  return orderedPresent.map((frequency) => ({
    frequency,
    total: frequencyTotals[frequency] ?? '0',
    suffixKey: `pricing.header.frequency_suffix.${toTranslationKeySegment(frequency)}`,
    fallbackSuffix: frequency === ONE_TIME_FREQUENCY ? 'one-time' : HEADER_SUFFIX_FALLBACKS[frequency],
  }));
};
